import noodleApiClient from '@noodleApi';

const linkStripeAccount = async ({ creatorId }: { creatorId: string }): Promise<string> => {
  const { data } = await noodleApiClient.get(`/stripe/link-creator/${creatorId}`);
  return data;
};

export default linkStripeAccount;
